import { Path, isEmpty, isNil, pathOr } from 'ramda';

import { required } from './required';
import { TValidator } from './types';

export const requiredAtLeastOneOfFields: (keys: Path[]) => TValidator = (keys) => (value, allValues) => {
  if (!keys.length) {
    return undefined;
  }

  const partialResults = keys.map((keyItem) => {
    const keyValue = pathOr(undefined, keyItem, allValues);

    return isEmpty(keyValue) || isNil(keyValue);
  });

  const emptyResults = partialResults.filter((partialResult) => !!partialResult);

  // at least one of required fields is not empty
  if (emptyResults.length !== partialResults.length) {
    return undefined;
  }

  return required(value);
};
